// Modules
import React from "react";
import PropTypes from "prop-types";

const CloseIcon = (props) => {
	const {
		clssName,
		onClick,
	} = props;

	return (
		<svg
			width="13"
			height="13"
			viewBox="0 0 13 13"
			className={`close-icon-container ${clssName}`}
			xmlns="http://www.w3.org/2000/svg"
			onClick={onClick}
		>
			<path
				className="closed"
				d="M0 0.766797L0.766797 0L6.5 5.7332L12.2332 0L13 0.766797L7.2668 6.5L13 12.2332L12.2332 13L6.5 7.2668L0.766797 13L0 12.2332L5.7332 6.5L0 0.766797Z"
				
			/>
		</svg>
	);
};

CloseIcon.propTypes = {
	clssName: PropTypes.string,
	onClick: PropTypes.func,
};

CloseIcon.defaultProps = {
	clssName: "",
	onClick: () => {},
};

export default CloseIcon;
